import { CanDeactivateFn } from '@angular/router';
import { ConsumerQuizService } from '../../services/consumer-quiz/consumer-quiz.service';
import { inject } from '@angular/core';

export const quizUnsavedChangesGuard: CanDeactivateFn<unknown> = async (component, currentRoute, currentState, nextState) => {
	const consumerQuizService = inject(ConsumerQuizService);
	if (consumerQuizService.inProgress) {
		const result = await consumerQuizService.openPopup();
		return result;
	}
	return true;
};
